import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import IconButton from "@mui/material/IconButton";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import NavItems from "./navigation";

import { Box, Divider, Grid, Drawer as MuiDrawer, styled } from "@mui/material";

import { clientAdmin } from "../../../../Constants";
import {
  getApporovalList,
  getCalenderApporovalList,
} from "../../../../modules/Approvals/Approvals.helper";
import { getAllClientList } from "../../../../modules/Client/Client.helper";
import {
  fetchDashboardCalendar,
  fetchDashboardData,
} from "../../../../modules/Dashboard/Dashboard.helper";
import {
  getInvoiceGraphList,
  getPaidnvoiceList,
  getPendingInvoiceList,
} from "../../../../modules/Invoice/Invoice.helper";
import { getAllMemberList } from "../../../../modules/People/People.helper";
import {
  getAllWorkClients,
  getUsersListList,
} from "../../../../modules/Users/User.helper";
import { setClientCode } from "../../../../redux/Client/clientSlice";
import { setClientHeader } from "../../../../services/BaseApi";
import { TeamifiedRoles } from "../../../../utils/CommonFunction";
import { usePermissions } from "../../../../utils/permission";
import PopoverSelect from "../../../components/PopoverSelect/PopoverSelect";

const drawerWidth = 220;

const DrawerWrapper = styled(Box)(({ theme }) => ({}));

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled(Box, {
  shouldForwardProp: (prop) => prop !== !["open"].includes(String(prop)),
})(({ theme, open }) => ({
  position: `fixed`,
  top: 70,
  left: open ? 240 : 64,
  marginLeft: -12,
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-end",
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create("left ", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

function SideNav(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(true);

  const { userInfo } = useSelector((state) => state.login);
  const { bodyPayload } = useSelector((state) => state.approval);

  const { Dashboard_Invoices, Client } = usePermissions();
  const { allWorkableClients } = useSelector(
    //@ts-ignore
    (state) => state.hire,
  );

  const { clientCode, clientName } = useSelector(
    //@ts-ignore
    (state) => state.client,
  );

  const memoizedClientList = useMemo(() => {
    return allWorkableClients.map((e) => ({
      name: e.name,
      value: e.id,
      url: e.logoImageURL ? e.logoImageURL : "/static/images/avatar/1.jpg",
    }));
  }, [allWorkableClients]);

  useEffect(() => {
    const filteredArray = userInfo.role
      ?.split(",")
      .filter((r) => TeamifiedRoles.includes(r));
    if (filteredArray.length) {
      getAllWorkClients(dispatch);
    }
  }, [dispatch, userInfo]);

  const handleDrawerToggle = useCallback(() => {
    setMobileOpen((prev) => !prev);
  }, []);

  const drawer = (
    <Box
      sx={{
        textAlign: "left",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          py: 2,
          pl: 2,
          display: "flex",
          mt: 1,
          px: 2,
          justifyContent: "center",
          alignItems: "center",
          height: 40,
        }}
      >
        <img
          src={
            mobileOpen
              ? "/images/Teamified-black-logo.png"
              : "/images/favicon.png"
          }
          style={{
            width: mobileOpen ? "70%" : 28,
            height: mobileOpen ? "100%" : 28,
            transition: "all 0.4s cubic-bezier(0.4,0,0.2,1)",
            opacity: mobileOpen ? 1 : 1,
            transform: mobileOpen ? "scale(1)" : "scale(1.2) rotate(360deg)",
          }}
          alt="logo"
          key={mobileOpen ? "full-logo" : "icon-logo"}
        />
      </Box>
      <Divider />
      <Grid container justifyContent={"center"} alignItems={"center"}>
        {Client ? (
          <PopoverSelect
            showAll
            buttonText={"All"}
            onChange={(e) => {
              const val = e === "" ? 0 : e;
              dispatch(setClientCode(val));
              setClientHeader(val);
              const path = location.pathname.replace("/", "").toLowerCase();

              setTimeout(() => {
                switch (path) {
                  case "hire":
                    break;
                  case "team-members":
                    getAllMemberList(dispatch);
                    break;
                  case "client":
                    getAllClientList(dispatch);
                    break;
                  case "users":
                    getUsersListList(dispatch, true, 1, clientAdmin);
                    break;
                  case "leave":
                    let approvalPayload = { load: 0 };
                    if (bodyPayload.period !== undefined) {
                      approvalPayload = bodyPayload;
                    }
                    getApporovalList(dispatch, approvalPayload);
                    const date = new Date();
                    const updatedYear = date.getFullYear();
                    const updatedMonth = date.getMonth() + 1;
                    const calenderPayload = {
                      year: updatedYear,
                      month: updatedMonth,
                      leaveTypeList: [],
                      leaveStatusList: [],
                      searchValue: "",
                    };
                    getCalenderApporovalList(dispatch, calenderPayload);
                    break;
                  case "invoices":
                    if (Dashboard_Invoices) {
                      getPendingInvoiceList(dispatch);
                      getInvoiceGraphList(dispatch);
                      getPaidnvoiceList(dispatch);
                    }

                    break;

                  default:
                    const payload = {
                      clientId: val,
                    };
                    if (Dashboard_Invoices) {
                      getPendingInvoiceList(dispatch);
                      getInvoiceGraphList(dispatch);
                      getPaidnvoiceList(dispatch);
                    }
                    fetchDashboardData(payload, dispatch);
                    setTimeout(() => {
                      fetchDashboardCalendar({}, dispatch);
                    }, 1000);
                  //fetchCountAndFilterData(dispatch);
                }
              }, 1000);
            }}
            options={memoizedClientList}
            value={clientCode === 0 ? "" : clientCode}
            drawerOpen={mobileOpen} // <-- Add this line
          />
        ) : null}
      </Grid>
      <NavItems
        close={handleDrawerToggle}
        drawerOpen={mobileOpen}
        openDrawer={() => setMobileOpen(true)} // <-- Add this prop
      />
    </Box>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      {/* Chevron button outside when closed */}
      <IconButton
        color="inherit"
        size="small"
        onClick={handleDrawerToggle}
        sx={{
          position: "absolute",
          left: mobileOpen ? `${drawerWidth - 12}px` : "54px",
          top: 32, // <-- Move higher to avoid overlap
          zIndex: 1301,
          width: 24,
          height: 24,
          backgroundColor: "#dfdfee",
          transition: "transform 0.3s left 0.3s",
          transform: mobileOpen ? "rotate(0deg)" : "rotate(180deg)",
          boxShadow: 2,
        }}
      >
        <ChevronLeftIcon />
      </IconButton>
      <Box component="nav">
        <DrawerWrapper>
          <Drawer container={container} variant={"permanent"} open={mobileOpen}>
            {drawer}
          </Drawer>
        </DrawerWrapper>
      </Box>
    </Box>
  );
}

SideNav.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default SideNav;
